<!--
  GPE customization (gov.ao): the three gantt controls, drawn rather than set.

  These were glyphs from the OpenProject icon font - heavy, solid, and at a
  different weight from everything else in this toolbar. The font file is
  generated, so a new drawing cannot be added to it by hand; the icons are
  inline SVG instead, in the line style the rest of this redesign is moving to:
  a 1.75 stroke in the current colour, round caps and joins, nothing filled.

  Sized and coloured from .timeline-toolbar--button in
  global_styles/content/_gpe_wp_toolbar.sass, so they follow the button they sit
  in rather than carrying their own metrics.
-->
<ul id="work-packages-timeline-mode-selection"
    class="toolbar-button-group work-packages-timeline-toggle-button">

  <li *ngIf="isActive">
    <button id="work-packages-timeline-zoom-auto-button"
            class="button timeline-toolbar--button toolbar-icon"
            [ngClass]="getAutoZoomToggleClass()"
            [attr.title]="text.zoomAuto"
            (click)="enableAutoZoom()">
      <svg class="op-timeline-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M9 4H4v5" />
        <path d="M15 4h5v5" />
        <path d="M20 15v5h-5" />
        <path d="M4 15v5h5" />
      </svg>
    </button>
  </li>

  <li *ngIf="isActive">
    <button id="work-packages-timeline-zoom-out-button"
            class="button timeline-toolbar--button toolbar-icon"
            [attr.title]="text.zoomOut"
            [disabled]="isMaxLevel"
            (click)="updateZoomWithDelta(1)">
      <svg class="op-timeline-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <circle cx="10.5" cy="10.5" r="6.5" />
        <path d="m20 20-4.9-4.9" />
        <path d="M7.5 10.5h6" />
      </svg>
    </button>
  </li>

  <li *ngIf="isActive">
    <button id="work-packages-timeline-zoom-in-button"
            class="button timeline-toolbar--button toolbar-icon"
            [attr.title]="text.zoomIn"
            [disabled]="isMinLevel"
            (click)="updateZoomWithDelta(-1)">
      <svg class="op-timeline-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <circle cx="10.5" cy="10.5" r="6.5" />
        <path d="m20 20-4.9-4.9" />
        <path d="M7.5 10.5h6" />
        <path d="M10.5 7.5v6" />
      </svg>
    </button>
  </li>
</ul>
